
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.285 1.194c-.602.347-1.38 1.167-1.562 1.476-.01.8-.013 1.888-.014 3.002H5.574V3.066c0-.319-.115-1.084-.576-1.592-.55-.605-1.18-.669-1.795-.73l-.09-.01c-.644-.067-1.444.218-1.797.45-.384.255-.589.477-.908 1.053-.332.6-.408 1.47.082 2.084.653.815 1.27 1.532 1.636 1.937.322.355-.211 1-.597 1.331.279-.233.763-.67.94-.952.241-.386.364-1.266 0-1.93-.128-.233-.477-.555-.814-.865-.323-.299-.636-.587-.73-.776-.193-.386.048-1.157.53-1.592.483-.434 1.293-.548 1.882-.29.648.285.721.802.77 1.14l.002.019c.064 2.203.155 6.754 0 7.333-.154.58-.579.724-.772.724L2.227 9.34.49 10.4c.134-.039.36-.039.826 0 .312.026.899.668 1.153 1.002.214-.133.843-.541 1.64-1.11.797-.567 1.31-1.729 1.465-2.24V5.997H9.71c0 2.304.013 4.611.014 4.63.02.362.574.635.92.807l.121.06s.756.05 1.2-.12c.36-.138.547-.245.796-.487.337-.327.648-.715.888-1.014.079-.097.15-.186.212-.26h-1.273l-.174.84c-.134.434-.506.682-.833.682-.52 0-.527-.682-.527-.682s-.162-8.054 0-8.68c.162-.624.57-.53.753-.404l.78 1.186 1.274-.781L12.76.5c-.24.087-.873.347-1.475.694z","fill":"#000C1F"}})])
          )
        }
      }
    